import { useEffect, useState } from 'react'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import useChallengeSelector from '../../hooks/useChallengeSelector'
import { BeltType, ParamsType } from '../../model/model'
import { fetchChallenges } from '../../store/challengeSlice'
import { useAppDispatch, useAppSelector } from '../../store/store'
import Progress from '../Progress/Progress'

const Belt = () => {
  const params = useParams()
  const config = useAppSelector((store) => store.config)
  const belts = useAppSelector((store) => store.belt)
  const user = useAppSelector((store) => store.user)
  const students = useAppSelector((store) => store.student.students)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { userID } = useParams<ParamsType>()

  const beltID = Number(belts.nameMap[params.activeTab])
  const challenges = useChallengeSelector(beltID)

  const [studentBeltData, setStudentBeltData] = useState<BeltType | undefined>(undefined)

  useEffect(() => {
    if (!params.activeChallenge) {
      if (beltID && !challenges.length) {
        dispatch(
          fetchChallenges({
            beltID: beltID
          })
        )
      }
    }
  }, [beltID, challenges, dispatch, navigate, params.activeChallenge])

  useEffect(() => {
    if (!params.activeChallenge && challenges.length) {
      navigate(challenges[0].id, {
        replace: true
      })
    }
  }, [challenges, navigate, params.activeChallenge])

  useEffect(() => {
    if (config.rank || (userID && Object.keys(students).length)) {
      setStudentBeltData(
        belts.list.reduce((result, obj) => {
          if (config.rank && obj.id === config.rank) {
            return obj
          } else if (obj.id === students[userID]?.rank) {
            return obj
          }

          return result
        }, {} as BeltType)
      )
    }
  }, [belts.list, config.rank, students, userID])

  const { selectedBeltData, nextBeltData } = belts.list.reduce(
    (result, obj, idx) => {
      if (obj.id === beltID) {
        return {
          ...result,
          selectedBeltData: obj,
          nextBeltData: belts.list.length >= idx + 1 ? belts.list[idx + 1] : undefined
        }
      }

      return result
    },
    {
      selectedBeltData: {},
      nextBeltData: undefined
    } as {
      selectedBeltData: BeltType
      nextBeltData: BeltType | undefined
    }
  )

  return (
    <>
      {user.ratingByBelt[beltID]?.passing_percentage > 0 && (
        <Progress
          data={user.ratingByBelt[beltID]}
          beltName={selectedBeltData.title}
          color={studentBeltData?.color || undefined}
          nextBeltName={nextBeltData ? nextBeltData.title : undefined}
        />
      )}

      <Outlet />
    </>
  )
}

export default Belt
